import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock } from "lucide-react";
import Layout from "@/components/layout/Layout";
import PageHeader from "@/components/layout/PageHeader";
import Seo from "@/components/Seo";
import { BLOG_POSTS } from "@/data/blogData";

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("bg-BG", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

const BlogPage = () => {
  return (
    <Layout>
      <Seo path="/blog" />

      <PageHeader
        subtitle="Полезно съдържание"
        title="Блог"
        description="Експертни статии за кол център услуги, чат канали и обслужване на клиенти"
      />

      <section className="section-padding bg-white" data-testid="blog-list">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BLOG_POSTS.map((post) => (
              <article
                key={post.slug}
                className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden card-hover flex flex-col"
                data-testid={`blog-card-${post.slug}`}
              >
                <Link to={`/blog/${post.slug}`} className="block overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-52 object-cover transition-transform duration-500 hover:scale-105"
                    loading="lazy"
                  />
                </Link>
                <div className="p-6 flex flex-col flex-grow">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-semibold text-[#2ED573] uppercase tracking-wider">
                      {post.category}
                    </span>
                  </div>
                  <h2 className="text-xl font-bold text-[#2E4A91] mb-3 leading-snug">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="hover:text-[#2ED573] transition-colors"
                    >
                      {post.title}
                    </Link>
                  </h2>
                  <p className="text-slate-600 mb-5 flex-grow">{post.excerpt}</p>

                  <div className="flex items-center gap-4 text-sm text-slate-400 mb-4">
                    <span className="flex items-center gap-1.5">
                      <Calendar className="w-4 h-4" />
                      {formatDate(post.date)}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Clock className="w-4 h-4" />
                      {post.readTime}
                    </span>
                  </div>

                  <Link
                    to={`/blog/${post.slug}`}
                    className="text-[#2E4A91] font-medium flex items-center gap-2 hover:text-[#2ED573] transition-colors mt-auto"
                    data-testid={`blog-read-more-${post.slug}`}
                  >
                    Прочетете повече <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogPage;
